import { Text } from "@/atoms"
import { Heading } from "@/molecules/Heading"

import styles from "./ConnectPageHeading.module.scss"

import type { ConnectPageHeadingProps } from "./ConnectPageHeading.types"

export const ConnectPageHeading = ({
  title,
  description
}: ConnectPageHeadingProps) => (
  <div className={styles.title}>
    <Heading level={4} title={title} />
    {description && <Text type="secondary">{description}</Text>}
  </div>
)
